import { Flex } from "@chakra-ui/react"

import { ENABLE_SWAPS, routes } from "#/shared/constants"
import { useLandingRoute } from "#/shared/hooks"
import { DashboardHeaderAccount } from "#/ui/Layout"

import NavigationButton from "./Buttons/NavigationButton"

export default function AccountMenu() {
  const { isLandingRoute } = useLandingRoute()
  return (
    <Flex alignItems="center" gap={{ base: 3, lg: 5 }} zIndex={1}>
      {!isLandingRoute && (
        <NavigationButton to={routes.OVERVIEW} label="Deposit" />
      )}
      {ENABLE_SWAPS && <NavigationButton to={routes.SWAP} label="Swap" />}
      <DashboardHeaderAccount
        triggerProps={{
          signedOut: {
            size: "medium",
          },
        }}
      />
    </Flex>
  )
}
